module.exports = __webpack_public_path__ + "static/media/MachineLearningLeft.5cdf929f.svg";